import e from "@dialpad/dialtone-tokens/layered/themes/tokens-seashell-colors.css?inline";
//#region themes/seashell.js
var t = {
	brand: {
		css: e,
		name: "seashell"
	},
	material: { name: "sandstone" }
};
//#endregion
export { t as default };
